import { takeLatest } from 'redux-saga/effects';
import {
  getFinalPayListSuccess, getFinalPayListFail,
  getFinalPayDetailsSuccess, getFinalPayDetailsFail
} from './finalPayState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/finance/final-pays');
const redirectData = {route:'/console/final-pays', mode: 'list', recordId:0 };
const modelName = 'Final Pay';
const modelId = 'fpa_id';

function* getFinalPayList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getFinalPayListSuccess, 
		getFinalPayListFail,
		null, null, LOADING_MSG);
}

function* getFinalPayDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getFinalPayDetailsSuccess, 
		getFinalPayDetailsFail,
		null, null, LOADING_MSG);		
}

function* doFinalPayCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getFinalPayDetailsSuccess, 
		getFinalPayDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doFinalPayUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getFinalPayDetailsSuccess, 
		getFinalPayDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doFinalPayDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getFinalPayDetailsSuccess, 
		getFinalPayDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* doFinalPayProgressUpdate(data){

	console.log(data.payload);	
	const { finalPayId, process } = data.payload;
		
	yield doCrudCall(
		() => crudService.doPostRequest(`${finalPayId}/progress/update/${process}`, null), 
		getFinalPayDetailsSuccess, 
		getFinalPayDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		UPDATING_MSG);
}


function* finalPaySaga() {
  yield takeLatest('finalPay/getFinalPayList', getFinalPayList);
  yield takeLatest('finalPay/getFinalPayDetails', getFinalPayDetails);
  yield takeLatest('finalPay/doFinalPayCreate', doFinalPayCreate);
  yield takeLatest('finalPay/doFinalPayUpdate', doFinalPayUpdate);
  yield takeLatest('finalPay/doFinalPayDelete', doFinalPayDelete);  
  yield takeLatest('finalPay/doFinalPayProgressUpdate', doFinalPayProgressUpdate);  
  
}

export default finalPaySaga;
